import * as actions from "./actionsTypes";

const initialData = {
  loaderFactorCriterion: false,
  loaderFactorsCriteria: false,
  factorsCriteriaLenght: 0,
  saveLoaderFactorCriterion: false,
  factorsCriteria: null,
  factorCriterion: null,
  factorsCriteriaFail: null,
  factorCriterionFail: null,
  formFactorCriterionFail: null
};

export default function FactorsCriteriaReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_FACTORCRITERION:
      return { ...state, loaderFactorCriterion: action.payload };
    case actions.LOADER_FACTORSCRITERIA:
      return { ...state, loaderFactorsCriteria: action.payload };
    case actions.SAVE_LOADER_FACTORCRITERION:
      return { ...state, saveLoaderFactorCriterion: action.payload };
    case actions.GET_FACTORCRITERION:
      return { ...state, factorCriterion: action.payload };
    case actions.GET_FACTORSCRITERIA:
      return {
        ...state,
        factorsCriteria: action.payload.factorsCriteria,
        factorsCriteriaLenght: action.payload.factorsCriteriaLenght
      };
    case actions.FACTORCRITERION_FAIL:
      return { ...state, factorCriterionFail: action.payload };
    case actions.FACTORSCRITERIA_FAIL:
      return { ...state, factorsCriteriaFail: action.payload };
    case actions.FORM_FACTORSCRITERIA_FAIL:
      return { ...state, formFactorCriterionFail: action.payload };
    default:
      return state;
  }
}
